import styled from "styled-components";
import { useParams } from "react-router-dom";

import { PageContainer, SplitContent, WideCard } from "../styled";
import { useCompany } from "../../useCompany";

import { NoSurveysContainer } from "./NoSurveysContainer";
import { SurveyList } from "./SurveyList.tsx";
import { SurveySummaryContainer } from "./SurveySummaryContainer";

import { media } from "@otta/design";
import { Loading } from "@otta/search/components/Loading";

const LeftContainer = styled.div`
  width: 100%;

  ${media({ from: "tablet" })`
    max-width: 340px;
  `}
`;

const RightContainer = styled.div`
  width: 100%;
`;

export function CompanyEmployeeSurveys(): React.ReactElement | null {
  const { companyUrlSafeName } = useParams();
  const { data, loading } = useCompany(companyUrlSafeName as string);

  if (loading) {
    return <Loading />;
  }

  const company = data?.company;

  if (!company) {
    return null;
  }

  return (
    <PageContainer>
      <WideCard>
        {company.employeeSurveys.length > 0 ? (
          <SplitContent>
            <LeftContainer>
              <SurveySummaryContainer company={company} />
            </LeftContainer>
            <RightContainer>
              <SurveyList company={company} />
            </RightContainer>
          </SplitContent>
        ) : (
          <NoSurveysContainer company={company} />
        )}
      </WideCard>
    </PageContainer>
  );
}
